import React from 'react';
import _each from 'lodash/each';
import _find from 'lodash/find';
import {SimpleSelect} from 'react-selectize';
import decodeEntities from '../../tools/decodeEntitites';

class Select extends React.Component {

    constructor() {
        super();
        this.state = {
            items: []
        };
        this.portfolioSelected = this.portfolioSelected.bind(this);
    }
    addItems(){
        var options = [];

        _each(this.props.items, function(option){
            option.label = decodeEntities(option.name);
            option.value = option.slug;

            options.push(option);
        });

        this.setState({
            items: options,
            name: this.props.name
        });
    }
    componentWillReceiveProps(props, next){
        if(props.items !== next.items){
            this.addItems();
        }
        let l = this.state.value ? this.state.value.slug : false;

        if(props.activeSlug !== l){
            this.portfolioSelected(props.activeSlug);
        }


    }
    componentWillMount(){
        this.addItems();
    }
    portfolioSelected(name){
        if(_find(this.state.items, {slug: name}) === undefined){
            this.setState({value: ''});
        }
    }

    render(){
        var _this = this;
        return <div>
            <SimpleSelect
                ref = "select"
                placeholder = {this.state.name}
                options = {this.state.items}
                value = {this.state.value}
                // onValueChange :: Item -> (a -> Void) -> void
                onValueChange = {function(val){
                    _this.portfolioSelected(val);
                    if(val){
                        _this.props.updateItems(val.slug, val.taxonomy);
                        _this.setState({value: val});
                    }else{
                        _this.props.updateItems('any');
                    }
                }}

                // renderNoResultsFound :: a -> ReactElement
                renderNoResultsFound = {function() {
                    return <div className = "no-results-found">
                        {!self.req ? "loading portfolio ..." : "No results found"}
                    </div>
                }}
            />
        </div>
    }
}

export default Select;


/** WEBPACK FOOTER **
 ** ./src/js/components/parts/select.js
 **/